import { useCallback, useMemo } from 'react'
import LazyLoad from 'react-lazy-load'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { useTerritoryQueries } from 'hooks-queries/territory'
import { T } from 'lib/tolgee'
import { humanizeLargeNumber, TOLGEE_GLOBALS } from 'utils'

import { GET_TERRITORY_SAVED_POST_TOTAL_POST_LOG } from './videos-table-cell.consts'

const VideosTableCell = ({ territoryId, timeRange }) => {
  const { data, loading, error, called, refetch } = useTerritoryQueries({
    queryName: 'getTerritorySavedPostTotalPostById',
    queryVariables: { territoryId, timeRange },
    errorLog: GET_TERRITORY_SAVED_POST_TOTAL_POST_LOG,
    options: {
      skip: !territoryId,
    },
  })

  const videos = useMemo(() => {
    if (!called || loading || error || data?.getTerritory?.__typename !== 'SavedPostSearch') return

    return humanizeLargeNumber(data.getTerritory.territoryPerformance.totalPosts, 3)
  }, [called, data, loading, error])

  const handleTryAgain = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()

      refetch()
    },
    [refetch]
  )

  if (loading) {
    return (
      <SkeletonTheme baseColor="var(--color_neutral_400)" highlightColor="var(--color_neutral_200)">
        <Skeleton height={10} borderRadius={16} width={80} />
      </SkeletonTheme>
    )
  }

  if (error) {
    return (
      <button onClick={handleTryAgain}>
        <T keyName={TOLGEE_GLOBALS.tryAgain.key}>{TOLGEE_GLOBALS.tryAgain.defaultValue}</T>
      </button>
    )
  }

  return <>{videos}</>
}

export const VideosTableCellLazy = ({ row }) => (
  <LazyLoad>
    <VideosTableCell {...row} />
  </LazyLoad>
)
